import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Typography } from '@material-ui/core';
import QuestionHeader from './QuestionHeader';
import FormMapField from '../form/FormMapField';

const SubmissionLocationsProposal = ({ name, number, questionText, readonly, allowedAreas, choiceLimits, isOptional, proposedLocations, initialLocation }) => (
  <div className="box">
    <div className="col-sm-12">
      <QuestionHeader name={questionText} number={number} />
      {isOptional && <Typography variant="caption" color="textSecondary" display="block">Odpowiedź nie jest wymagana</Typography>}
      {allowedAreas && allowedAreas.length ? <Typography variant="caption" color="textSecondary" gutterBottom={choiceLimits.min || choiceLimits.max ? true : false} display="block">Możliwe jest wybranie punktów wyłącznie na terenie {allowedAreas.length === 1 ? "zdefiniowanego obszaru" : "zdefiniowanych obszarów"}</Typography> : null}
      {choiceLimits.min ? <Typography variant="caption" color="textSecondary" display="block">Minimalna liczba punktów do wybrania: {choiceLimits.min}</Typography> : null}
      {choiceLimits.max ? <Typography variant="caption" color="textSecondary" display="block">Maksymalna liczba punktów do wybrania: {choiceLimits.max}</Typography> : null}
      <div>
        <Field
          name={`${name}.locations`}
          component={FormMapField}
          disabled={readonly}
          allowedAreas={allowedAreas}
          choiceLimits={choiceLimits}
          existingProposedLocations={proposedLocations}
          initialLocation={initialLocation}
        />
      </div>
    </div>
  </div>
);

SubmissionLocationsProposal.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired,
  readonly: PropTypes.bool,
  isOptional: PropTypes.bool,
  choiceLimits: PropTypes.object.isRequired,
  allowExistingProposalChoice: PropTypes.bool,
  allowedAreas: PropTypes.array,
  proposedLocations: PropTypes.array.isRequired,
  initialLocation: PropTypes.object,
};

export default SubmissionLocationsProposal;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/SubmissionLocationsProposal.js